import React from 'react';
import block from 'bem-cn';

import Typography from '../../Typography';

import './medium-button.scss';

const b = block('medium-button');

enum Variants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  NEUTRAL = 'neutral',
  WARNING = 'warning',
}

type MediumButtonPropsType = {
  classes?: string[];
  title: string;
  variant: Variants;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const MediumButton = ({
  classes = [],
  title,
  variant,
  onClick,
}: MediumButtonPropsType) => {
  const rootClass = b({ [variant]: true });

  return (
    <div onClick={onClick} className={[rootClass, ...classes].join(' ')}>
      <Typography
        component='div'
        className={b('title').toString()}
        variant={Typography.THEME.VARIANTS.CARD_TAG_FAT}
      >
        {title}
      </Typography>
    </div>
  );
};

MediumButton.Variants = Variants;

export default MediumButton;
